import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Mobileapp(props) {
  return (
    <div className="mobileapp_gcc p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banenr_content">
              <h2>
                Work with Our Expert App Developers in Saudi Arabia and Digitize
                Your Business
              </h2>
              <p>
                Having a masterly team of developers is the key to creating a
                product that helps you identify your business in the digital
                market. To your business virtue, TekRevol possesses professional
                app developers in Saudi Arabia with expertise in building both
                iOS and Android applications.
              </p>
              <p>
                With a proven track record in the GCC region, we have
                facilitated multiple businesses from startup to enterprise
                level. Specializing in diverse mobile application development
                services, we tailor a solution that fits your requirements.
                Apart from the execution, you will have our regular consultancy
                under the supervision of our experts.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={7} xl={7} xxl={7} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/sa/expert.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={909}
              height={762}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Mobileapp;
